import { render, staticRenderFns } from "./BoldTextIcon.vue?vue&type=template&id=08b74bd0&scoped=true"
import script from "./BoldTextIcon.vue?vue&type=script&lang=js"
export * from "./BoldTextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b74bd0",
  null
  
)

export default component.exports